/**
 * Centralized status mappings for knowledge-graph components
 */

/**
 * Status icon mapping for visual representation
 */
export const STATUS_ICONS: Record<string, string> = {
  start: "⟳",
  running: "⟳",
  complete: "✅",
  error: "❌",
  default: "⏳",
};

/**
 * Status icon mapping for conversational display
 */
export const STATUS_ICONS_CONVERSATIONAL: Record<string, string> = {
  running: "💭",
  complete: "✨",
  error: "😕",
  default: "⏱️",
};

/**
 * Get status icon with fallback
 * @param status - Status identifier
 * @param conversational - Use conversational style icons
 * @returns Icon emoji for the status
 */
export const getStatusIcon = (
  status: string,
  conversational: boolean = false
): string => {
  if (conversational) {
    return (
      STATUS_ICONS_CONVERSATIONAL[status] || STATUS_ICONS_CONVERSATIONAL.default
    );
  }
  return STATUS_ICONS[status] || STATUS_ICONS.default;
};
